import { Fragment } from 'react'
import type { ReactElement } from 'react'
import styled from 'styled-components'

import { cpMapList } from './CPMapList'
import { MapCard } from './MapCard'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { CompanyLinks } from '@/components/enlayouts/Company/CompanyLinks'
import { Head } from '@/components/enlayouts/Head'

const sectionTitle = {
  enTitleText: 'Access',
}

export const AccessPage = () => {
  return (
    <>
      <Head
        title="Access"
        description="Access details to TRIAL Holdings, Inc.&apos;s offices."
        ogp={{ type: 'article', url: 'en/company/access/' }}
      />
      <AccessContainer>
        <Spacer h={{ sp: 40, pc: 69 }} />
        <SectionTitle
          color="normal"
          enTitleText={sectionTitle.enTitleText}
        />
        <Spacer h={{ sp: 58, pc: 129 }} />
        {cpMapList.map((value, index) => (
          <Fragment key={value.addressUrl}>
            <MapCard {...value} />
            {index !== cpMapList.length - 1 && (
              <Spacer h={{ sp: 41, pc: 76 }} />
            )}
          </Fragment>
        ))}
        <CompanyLinks padding={{ pc: '130px 0 0' }} />
      </AccessContainer>
    </>
  )
}
AccessPage.getLayout = function getLayout(page: ReactElement) {
  const pageTitle = {
    title: 'Corporate Information',  
    subTitle: '',
  }

  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Corporate Information', path: '/en/company/' },
    { name: 'Access', path: '' },
  ]

  return (
    <TitleLayout {...pageTitle} breadCrumbs={breadCrumbs} isRequiredBackground>
      {page}
    </TitleLayout>
  )
}

const AccessContainer = styled.div`
  width: 1040px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 0px 20px 75px;
  }
`
